import { Component, ElementRef, inject, Input, OnInit, ViewChild } from '@angular/core'

import { FormsModule } from '@angular/forms'
import { IonicModule, ModalController } from '@ionic/angular'
import { FileUploadService } from '../../../services/file-upload.service'
import { Announcement } from '../../../models/announcement'
import { FileViewerService } from '../../../services/fileViewer/file-viewer.service'
import {
  HtmlEditorService,
  ImageService,
  ImageSettingsModel,
  LinkService,
  QuickToolbarService,
  RichTextEditorAllModule,
  ToolbarService,
} from '@syncfusion/ej2-angular-richtexteditor'
import { FileSizePipe } from '../../../shared/pipes/file-size.pipe'
import { AnnouncementsService } from '../../../services/domain/announcements/announcements.service'
import { BypassHtmlSanitizerPipe } from '../../../shared/pipes/bypass-html-sanitizer.pipe'

@Component({
  selector: 'app-announcement-viewer',
  standalone: true,
  imports: [FormsModule, IonicModule, RichTextEditorAllModule, FileSizePipe, BypassHtmlSanitizerPipe],
  providers: [ToolbarService, LinkService, HtmlEditorService, ImageService, QuickToolbarService],
  templateUrl: './announcement-viewer.component.html',
  styleUrls: ['./announcement-viewer.component.scss'],
})
export class AnnouncementViewerComponent implements OnInit {
  private modalCtrl = inject(ModalController)
  private fileViewerService = inject(FileViewerService)
  private fileUploadService = inject(FileUploadService)
  private announcementService = inject(AnnouncementsService)

  @Input() message: Announcement
  @Input() canEdit = false
  @Input() openInEditMode = false
  @ViewChild('fileInput') fileInput: ElementRef

  messageForEditing: Announcement

  size: number
  mode: 'view' | 'edit' = 'view'

  FileUploadService = FileUploadService
  public tools: object = {
    type: 'MultiRow',
    enableFloating: false,
    items: [
      'Undo',
      'Redo',
      '|',
      'Bold',
      'Italic',
      'Underline',
      'StrikeThrough',
      '|',
      'BackgroundColor',
      '|',
      'Formats',
      '|',
    ],
  }
  rteInsertImageSettings: ImageSettingsModel = {
    saveFormat: 'Base64',
  }

  async ngOnInit() {
    if (this.message.attachmentUri) this.size = (await this.fileUploadService.getSize(this.message.attachmentUri)).size
    if (this.openInEditMode) this.edit()
  }

  close() {
    this.modalCtrl.dismiss()
  }

  viewAttachment() {
    if (this.message.attachmentUri) {
      this.fileViewerService.viewIfPdfElseDownload(this.message.attachmentUri)
    }
  }

  edit() {
    if (this.canEdit) {
      this.mode = 'edit'
      console.log('announcement', this.message)
      this.messageForEditing = this.message.shallowClone()
    }
  }

  async save() {
    if (this.mode === 'edit') {
      console.log('changes', this.messageForEditing.extractChanges(this.message))
      this.message = await this.announcementService.patch(
        this.message.id,
        this.messageForEditing.extractChanges(this.message),
      )
      this.mode = 'view'
    }
  }

  removeAttachment() {
    this.messageForEditing.attachmentUri = null
  }
  selectFile() {
    this.fileInput.nativeElement.click()
  }
  async onFileInput() {
    console.log('onfileinput', this.fileInput.nativeElement.files)

    if (this.fileInput.nativeElement.files.length > 0) {
      const fileUpload = await this.fileUploadService.upload(this.fileInput.nativeElement.files[0])
      const documentUri = fileUpload.id
      this.size = fileUpload.size
      this.messageForEditing.attachmentUri = documentUri
    }
  }
}
